
const hosturl= 'http://47.97.5.38:7321/bena';
//const hosturl= 'http://localhost:8000';
// 本地环境
module.exports = {
    NODE_ENV: '"development"',
    hosturl:hosturl,
    downloadurl:'http://101.201.181.152:8000/',
    blasturl:"http://47.97.5.38"
}
